import Button from '@creator/ui/components/Button/ButtonV2';
import Text from '@creator/ui/components/Text/Text';
import { cn } from '@creator/ui/utils/ui';
import { memo } from 'react';

interface TopicGhostChipProps {
    className?: string;
    id: string;
    name: string;
    isActive?: boolean;
}

function getBaseStyles() {
    return 'flex items-center cursor-pointer shrink-0 font-medium';
}

const TopicGhostChip: React.FC<TopicGhostChipProps> = props => {
    const { name, isActive = false, className = '' } = props;

    function getButtonColor() {
        if (isActive) return 'primary';
        return 'base-dark-only';
    }

    return (
        <Button key={name} className={cn(getBaseStyles(), className)} size="sm" variant="ghost" color={getButtonColor()}>
            <Text>{name}</Text>
        </Button>
    );
};

export default memo(TopicGhostChip);
